// removed by extract-text-webpack-plugin
module.exports = {"LargeEventCardWrapper":"src-components-LargeEventCard-__LargeEventCard-module___LargeEventCardWrapper","LargeEventCardLocation":"src-components-LargeEventCard-__LargeEventCard-module___LargeEventCardLocation","LargeEventCardName":"src-components-LargeEventCard-__LargeEventCard-module___LargeEventCardName","LargeEventCardMonth":"src-components-LargeEventCard-__LargeEventCard-module___LargeEventCardMonth"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeEventCard/LargeEventCard.module.css
// module id = 1027
// module chunks = 0